import { Container, Row, Col, Table, Button, Form, Spinner, Alert, Card, FormControl } from 'react-bootstrap';
import React, { useEffect, useState } from "react";
import { getProcess_trackers } from '../../services/aiNews';
import LogViewerModal from '../../components/news/LogViewerModal';
import Loading from '../../components/layout/Loading';

function AiNewsLogViewer() {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedId, setSelectedId] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [recordLimit, setRecordLimit] = useState(12);
    const [isLoading, setIsLoading] = useState(false);
    const [filtering, setFiltering] = useState('');
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize] = useState(10);

    const openModal = (id) => {
        setShowModal(true)
        setSelectedId(id);
    }

    const onChangeRecordLimit = (e) => {
        setRecordLimit(parseInt(e.target.value));
    }

    const totalPages = Math.ceil(filteredData.length / pageSize);
    const startIndex = currentPage * pageSize;
    const endIndex = startIndex + pageSize;
    const currentData = filteredData.slice(startIndex, endIndex);

    useEffect(()=> {
        setIsLoading(true);
        getProcess_trackers(recordLimit).then((list) => {
            setData(list);
            setFilteredData(list);
        }).finally(() => setIsLoading(false));
    },[recordLimit])

    useEffect(() => {
        const filtered = data.filter(item => {
            const matchesSearch = !filtering || 
                item.id.toString().includes(filtering) ||
                item.created_at.toLowerCase().includes(filtering.toLowerCase()) ||
                (item.tag && item.tag.toLowerCase().includes(filtering.toLowerCase()));
            return matchesSearch;
        });
        setFilteredData(filtered);
        setCurrentPage(0); // Reset to first page when filtering
    }, [filtering, data]);
    return (
        <>
        <Container>
            {/* Controles de filtro y configuración */}
            <Row className="mt-3">
                <Col xs={12} sm={6} md={4} className="d-flex align-items-center">
                    <input
                        type="text"
                        className="form-control me-3"
                        placeholder="Buscar por ID, fecha o tag..."
                        value={filtering}
                        onChange={e => setFiltering(e.target.value)}
                    />
                </Col>
                
                <Col xs={6} sm={3} md={2}>
                    <Form.Select aria-label="Seleccionar cantidad de registros" onChange={onChangeRecordLimit} value={recordLimit}>                                                
                        <option value={12}>12 registros</option>
                        <option value={25}>25 registros</option>
                        <option value={50}>50 registros</option>
                        <option value={100}>100 registros</option>
                        <option value={200}>200 registros</option>
                    </Form.Select>
                </Col>
            </Row>

            {isLoading ? (
                <Loading />
            ) : (
                <>
                    <Row>
                        <Col>
                            <Table className='mt-3' striped bordered hover responsive> 
                                <thead>                          
                                    <tr className='table-dark'>                            
                                        <th className='text-center'>Id</th>
                                        <th className='text-center'>Fecha/Hora</th>   
                                        <th className='text-center'>Duración</th>                                        
                                        <th className='text-center'>Contenido</th>                                                                              
                                    </tr>
                                </thead>
                                <tbody>
                                    { 
                                        currentData && currentData.length > 0 ? 
                                        currentData.map((item, index) => 
                                        (
                                            <tr key={index} >                            
                                                <td className='text-center'>{item.id}</td>
                                                <td className='text-center'>{item.created_at}</td> 
                                                <td className='text-center'>{item.minutes ? `${item.minutes} minutos`: item.tag}</td>                                           
                                                <td className='text-center'>
                                                    <Button 
                                                        variant="primary" 
                                                        size="sm"
                                                        onClick={() => openModal(item.id)}
                                                    >
                                                        <i className="bi bi-card-list"></i>
                                                    </Button>
                                                </td>                                                                              
                                            </tr>
                                        )) : (
                                            <tr>
                                                <td colSpan="4" className="text-center">
                                                    No hay datos disponibles
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    
                    {/* Paginación */}
                    {totalPages > 1 && (
                        <Row>
                            <Col>
                                <nav aria-label="Page navigation">
                                    <ul className="pagination">
                                        <li className={`page-item ${currentPage === 0 ? 'disabled' : ''}`}>
                                            <a className="page-link" onClick={() => setCurrentPage(0)}>&laquo;</a>
                                        </li>
                                        <li className={`page-item ${currentPage === 0 ? 'disabled' : ''}`}>
                                            <a className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>Anterior</a>
                                        </li>
                                        <li className={`page-item ${currentPage === totalPages - 1 ? 'disabled' : ''}`}>
                                            <a className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>Siguiente</a>
                                        </li>
                                        <li className={`page-item ${currentPage === totalPages - 1 ? 'disabled' : ''}`}>
                                            <a className="page-link" onClick={() => setCurrentPage(totalPages - 1)}>&raquo;</a>
                                        </li>
                                        <li className='page-item'>
                                            <a className="page-link disabled">{currentPage + 1}/{totalPages}</a>
                                        </li>
                                    </ul>
                                </nav>
                            </Col>
                        </Row>
                    )}
                </>
            )}
        </Container>
        <LogViewerModal show={showModal} handleClose={() => setShowModal(false)} id={selectedId} />
        </>
    );
}

export default AiNewsLogViewer;